import { render, staticRenderFns } from "./communityManagementsadd.vue?vue&type=template&id=7cc172da&"
import script from "./communityManagementsadd.vue?vue&type=script&lang=js&"
export * from "./communityManagementsadd.vue?vue&type=script&lang=js&"
import style0 from "./communityManagementsadd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports